<script>
    import { createEventDispatcher } from 'svelte'
    import SvelteFullCalendar from '../../../components/SvelteFullCalendar/SvelteFullCalendar.svelte'
    import BusyLayer from '../../../components/Modal/BusyLayer.svelte'
    // import { background, confirm } from '../../../stores/app'

    // export let height = 0
    export let items = []
    export let ref
    export let busy

    const dispatch = createEventDispatcher ();

    const options = {
        // height: $windowHeight - 40,
        // minHeight: $windowHeight - 40,
        contentHeight: 'auto',
        droppable: true,
        editable: true,
        showNonCurrentDates: false,
        headerToolbar: {
            start: '',
            center: '',
            end: ''
        },
        // eventResize: (info) => {
        //     console.log ('eventResize', info)
        // },
        // eventDisplay: 'block',
        eventClick: (info) => {
            // console.log ('eventClick', info, info.event.extendedProps)
            dispatch ('event-click', info.event.extendedProps)
        },
        eventDrop: (info) => {
            // console.log ('eventDrop', info.event.start.getTime ())
            dispatch ('event-drop', {
                ...info.event.extendedProps,
                ...{
                    start: info.event.start,
                    revert: info.revert
                }
            })
        }
        // eventDidMount: function(info) {
        //     var tooltip = new Tooltip(info.el, {
        //         title: info.event.extendedProps.description,
        //         placement: 'top',
        //         trigger: 'hover',
        //         container: 'body'
        //     });
        // },
    }

    $: events = items.filter (it => it._type === "program-item" && it.resolved === false).map (it => {
        return {
            title: (it.client ? it.client.name : '(client-unknown)') + ' - ' +  it.description,
            start: it.date,
            end: it.date,
            bean: it,
            color: it.resolved ? '#2ecc8a' : (it.type === 1 ? '#f5d48b' : '#7c9aa7'),
            // allDay: true
        }
    })
</script>

<div class="ProgramsCalendar page-pad avoid-selection">
    <SvelteFullCalendar bind:ref {events} {options} on:period-change />
</div>

{#if busy}
    <BusyLayer />
{/if}

<style>
    .ProgramsCalendar :global(.fc-header-toolbar) {
        margin-bottom: 0;
    }
</style>

